// Environment DEV — deploy su Azure App Service amsuite-ui-dev
// Backend AmSuite = PROD; AuthN/Workspace/Notifier = DEV; MSAL = tenant nwamdev (DEV).
// Auth/B2C/host del perimetro/cryptingKey/instrumentationKey vivono ora nella
// libreria `@neworg-net/amsuite-core` (host registry + profili ambiente, profilo `dev`).

import { AmSuitePlatformOptions } from '@neworg-net/amsuite-core';

export const amSuitePlatformOptions: AmSuitePlatformOptions = {
  appId: '02A42623-0D2A-4948-917E-D767D8F706DC',
  envProfile: 'dev',
  loginRoute: '/login',
  redirectUri: 'https://amsuite-dev.neworg.net/',
  postLogoutRedirectUri: 'https://amsuite-dev.neworg.net/login',
  isCookieWriter: true,
  iframeNoAuthStrategy: 'navigateToLogin',
};

export const environment = {
  production: true,
  amSuitePlatformOptions,

  routes: {
    config: {
      useHash: false,
      enableTracing: false
    }
  },

  // URL mappings PROD -> origin DEV. Le satellite usano domini .neworg.net
  // per leggere il cookie della shell; Admin Panel resta standalone su Azure.
  // Attivare DNS, binding/TLS, B2C e CORS prima del rilascio di questi mapping.
  devUrlMappings: [
    { from: 'suiteadmin.neworg.net', to: 'app-amsuite-admin-ui-dev-b7d7bdf8gxcpbbb7.westeurope-01.azurewebsites.net' },
    { from: 'amsuite.neworg.net', to: 'amsuite-dev.neworg.net' },
    { from: 'crm.neworg.net', to: 'amcrmui-dev.neworg.net' },
    { from: 'calendar.neworg.net', to: 'calendar-dev.neworg.net' },
    { from: 'reportbi.neworg.net', to: 'reportbi-dev.neworg.net' },
    { from: 'dialog.neworg.net', to: 'dialog-dev.neworg.net' },
    { from: 'fastpublisher.neworg.net', to: 'fastpublisher-dev.neworg.net' },
    { from: 'suiteautomation.neworg.net', to: 'suiteautomation-dev.neworg.net' },
    { from: 'attendancesheet.neworg.net', to: 'attendancesheet-dev.neworg.net' },
    { from: 'partysharedarchive.neworg.net', to: 'partysharedarchive-dev.neworg.net' },
    { from: 'billing.neworg.net', to: 'billing-dev.neworg.net' },
    { from: 'refundedcosts.neworg.net', to: 'refundedcosts-dev.neworg.net' },
    { from: 'amsuite-amcomunica.neworg.net', to: 'amsuite-amcomunica-dev.neworg.net' },
    { from: 'amsuiteassistant.neworg.net', to: 'amsuiteassistant-dev.neworg.net' },
    { from: 'amsuite-manageusers.neworg.net', to: 'amsuite-manageusers-dev.neworg.net' },
    { from: 'partyprofile.neworg.net', to: 'partyprofile-dev.neworg.net' }
  ] as Array<{ from: string; to: string }>
};
